export default __webpack_public_path__ + "static/media/various-banner.e5e54ed1.png";